export { default as BLIND } from './blind.svg'
export { default as CHART } from './chart.svg'
export { default as CHART_GRAYSCALE } from './chart_grayscale.svg'
export { default as EMPTYSTATE } from './emptystate.svg'
export { default as ERROR } from './error.svg'
export { default as KNIFE } from './knife.svg'
export { default as LASER } from './laser.svg'
export { default as MEDICINEBOTTLE } from './medicinebottle.svg'
export { default as MEMO } from './memo.svg'
export { default as NOTICE } from './notice.svg'
export { default as NOTIFICATION } from './notification.svg'
export { default as PILL_1 } from './pill-1.svg'
export { default as PILL_2 } from './pill-2.svg'
export { default as PRESSSUIT_BOTTOM } from './presssuit-bottom.svg'
export { default as PRESSSUIT_TOP } from './presssuit-top.svg'
export { default as PRESSSUIT } from './presssuit.svg'
export { default as SCAR } from './scar.svg'
export { default as SENDMAIL } from './sendmail.svg'
export { default as SHOT } from './shot.svg'
export { default as STAR } from './star.svg'
export { default as STETHOSCOPE } from './stethoscope.svg'
export { default as SURGICALGLOVES } from './surgicalgloves.svg'
export { default as TELEPHONE } from './telephone.svg'
export { default as THUMBSUP } from './thumbsup.svg'
export { default as SAD_PUMPKIN } from './sad_pumpkin.svg'
export { default as MAGNIFYING_GLASS_DOCUMENT } from './magnifying-glass-document.svg'
